import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../ui/Button";
import { WaypointCardProps } from "../../types/screensTypes";
import styles from "./WaypointCard.module.css";

const WaypointCard: React.FC<WaypointCardProps> = ({
    name,
    position,
    onClick,
    onDelete,
    dragHandleProps,
    color = "white",
    isLoading = false,
    isStop = false,
}) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const deleteButton = (
        <Button
            label={isLoading ? t("loading") : t("delete")}
            onClick={() => {
                if (!isLoading) {
                    const confirmed = window.confirm(t("deleteConfirmation"));
                    if (confirmed) {
                        onDelete();
                    }
                }
            }}
            isSmall={true}
            variant="danger"
            shape="pill"
            className={isStop ? styles.deleteBtnStop : styles.deleteBtn}
            preventDefault={true}
        />
    );

    if (isStop) {
        return (
            <div className={`${styles.card} ${styles.cardStop}`} style={{ background: color }}>
                <div className={styles.topStop}>
                    <div className={styles.dragHandle} {...dragHandleProps}>
                        <span>⠿</span>
                    </div>
                </div>
                <div
                    className={styles.content}
                    onClick={(e) => {
                        e.preventDefault();
                        onClick();
                    }}
                >
                    <p className={`${styles.name} ${styles.nameStop}`}>{name}</p>
                </div>
                <div className={styles.footer}>
                    <p className={`${styles.position} ${styles.positionStop}`}>
                        {t("positionWithSemicolon")} {position}
                    </p>
                    {deleteButton}
                </div>
            </div>
        );
    }

    return (
        <div className={styles.card} style={{ background: color }}>
            <div className={styles.top}>
                <div className={styles.dragHandle} {...dragHandleProps}>
                    <span>⠿</span>
                </div>
                {deleteButton}
            </div>
            <div
                className={styles.content}
                onClick={(e) => {
                    e.preventDefault();
                    onClick();
                }}
            >
                <p className={styles.name}>{name}</p>
                <p className={styles.position}>
                    {t("positionWithSemicolon")} {position}
                </p>
            </div>
        </div>
    );
};

export default WaypointCard;
